import { useMutation } from "@tanstack/react-query";
import { getMe, login } from "@/adapters/api";
import { queryClient } from "@/adapters/tanstack-query/query-client.ts";
import type { LoginFormValues } from "@/features/auth/schemas/login-schema";
import { type AuthSession, useAuth } from "@/store/use-auth";

export interface LoginOutcome {
	needsOnboarding: boolean;
}

async function signInWithPassword(
	values: LoginFormValues,
): Promise<LoginOutcome> {
	const { jwt, accounts } = await login(values);

	const me = await getMe(jwt).catch(() => null);

	const session: AuthSession = {
		token: jwt,
		user: me
			? { name: me.user.name, email: me.user.email }
			: { name: "", email: values.email },
		provider: "password",
	};
	useAuth.getState().signIn(session);

	if (me) {
		queryClient.setQueryData(["me"], me);
		return { needsOnboarding: me.user.onboarding ?? me.accounts.length === 0 };
	}

	return { needsOnboarding: accounts.length === 0 };
}

export function useLogin() {
	return useMutation({ mutationFn: signInWithPassword });
}
